import { usersListConstants } from 'Constants/usersList.constants'
import Request from 'Services/request.js';
import { findCurrentPageRequest,queryParser } from 'Helpers/urlform'
import {  formatDateTime } from 'Components/Common/TimeStamp';
import { handleApiError } from 'Helpers/index';

const requestUserList = usersList =>({
    type:usersListConstants.USERS_LIST_REQUEST,
    usersList
})

const sucessUsersList = usersListObject => ({
    type:usersListConstants.USERS_LIST_SUCCESS,
    usersListObject:usersListObject.data,
    totalRecords:usersListObject.count,
    currentPage:usersListObject.currentPage
})

const failureUserList = error => ({
    type:usersListConstants.USERS_LIST_FAILURE,
    error
})
/** Users Registration Management module */

function fetchUsersList(SearchArray) {
  let url = '/users' ;
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  const currentPage = findCurrentPageRequest(SearchArray);
  return async (dispatch) => {
    dispatch(requestUserList({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data = [], count } = response;
        dispatch(sucessUsersList({ data, count, currentPage }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureUserList(error.toString()));
        }
      });
  };
}

const requestUserExportData = (exportData, CON) => ({
  type: CON, 
  exportData
})

const successUserExportData = (exportDataObj, CON) => ({
  exportUsersId: Date.now(),
  type: CON,
  exportData: exportDataObj.data,
  totalRecords: exportDataObj.count
})

const failureUserExportData = (error, CON) => ({
  type: CON,
  error
})

function exportUsers(SearchArray) {
  let url = '/users';
  if (SearchArray && SearchArray.length > 0) {
    url = queryParser(url, SearchArray);
  }
  const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
  
  url = `${ url }${ exportUrl }`;
  return async (dispatch) => {
    dispatch(requestUserExportData({}, usersListConstants.EXPORT_USERS_REQUEST));
    await Request.get(url, {})
      .then(( response ) => {
        const { data = [] } = response;
        const dataToUpdate = [];
        data.forEach(function(res){ 
          const resObj = {};
          const registeredAt = formatDateTime(res.registeredAt);
          resObj[ 'Name' ] = res.name;
          resObj[ 'Mobile Number' ] = res.mobileNumber;
          resObj[ 'Email' ] = res.emailId;
          resObj[ 'Registered Date' ] = registeredAt && registeredAt;
          const deviceType = res.deviceType === '' || res.deviceType === null ? 'web' : res.deviceType;
          const deviceVersion = (deviceType !== 'web' && res.deviceVersion) ? (' ' + res.deviceVersion) : '';
          resObj[ 'Device Platform' ] = deviceType + deviceVersion;
          dataToUpdate.push(resObj);
        });
        dispatch(successUserExportData({ data: dataToUpdate }, usersListConstants.EXPORT_USERS_SUCCESS));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureUserExportData(error.toString(), usersListConstants.EXPORT_USERS_FAILURE));
        }
      });
  };    
}

function exportUsersStatus(status) {
  return {
    type: usersListConstants.EXPORT_USERS_STATUS,
    exportUsersId:  Date.now(),
    status,
  }
}

export const usersListActions={
    fetchUsersList,
    exportUsers,
    exportUsersStatus,
}